import { Directive, ElementRef, effect, inject, input } from '@angular/core';

@Directive({ selector: '[iotPlatformScrollIntoElement]', standalone: true })
export class ScrollIntoElementDirective {
  private readonly el = inject(ElementRef<HTMLElement>);

  iotPlatformScrollIntoElement = input<unknown>(null);

  constructor() {
    effect((onCleanup) => {
      if (!this.iotPlatformScrollIntoElement()) return;
      let timer: ReturnType<typeof setTimeout>;
      const observer = new ResizeObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          observer.disconnect();
          this.el.nativeElement.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }, 100);
      });
      observer.observe(this.el.nativeElement);
      onCleanup(() => {
        observer.disconnect();
        clearTimeout(timer);
      });
    });
  }
}
